<template>
  <div id="subtenant-choice-form">
    <header class="panel__header mt-2">
      <div class="row">
        <div class="col-8">
          <h2 class="panel__title">Escolha o seu time do coração</h2>
        </div>
        <div class="col-4">
          <select
            class="form-select"
            v-model="selectedGroup"
            name="groups"
          >
            <option v-for="group in groups" :key="group" :value="group"> Série {{ group }} </option>
          </select>
        </div>
      </div>
    </header>

    <div id="form-dados-pessoais" class="row mt-4">
      <div class="col-12">
        <div class="row g-3">
          <div
            v-for="subtenant in selectedGroupSubtenants"
            :key="subtenant.id"
            class="col-3 col-md-custom-team d-flex justify-content-center align-items-center"
          >
            <div
              :class="['shield-circle', { 'shield-circle--active': subtenant.id == currentSubtenant.id }]"
              @click="chooseSubtenant(subtenant)"
            >
              <img class="shield-circle__img" :src="subtenant.shield_url" :alt="`Escudo do ${subtenant.name}`">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <b-alert
          variant="danger"
          :show="error.show"
          v-model="error.show"
        >
          <div>{{ error.message }}</div>
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      selectedGroup: null,
      currentSubtenant: {
        id: 0
      },
      error: {
        show: false,
        message: ''
      }
    }
  },
  mounted() {
    this.selectedGroup = this.groups[0]
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    subtenants: {
      required: true,
      type: Array
    },
  },
  methods: {
    submit() {
      if (!this.validate()) {
        this.error.show = true
        this.error.message = "Você precisa escolher um time para prosseguir"
        return false
      } else {
        this.user.subtenant = this.currentSubtenant
        return true
      }
    },
    validate() {
      return this.currentSubtenant.id != 0
    },
    chooseSubtenant(subtenant) {
      this.currentSubtenant = subtenant
    }
  },
  computed: {
    groups() {
      return Array.from(new Set(this.subtenants.map(subtenant => subtenant.group)))
    },
    selectedGroupSubtenants() {
      return this.subtenants.filter(subtenant => subtenant.group === this.selectedGroup)
    }
  }
})
</script>

<style scoped>
.shield-circle {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 3px solid transparent;
  background: #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.shield-circle:hover {
  border-color: var(--primary);
}

.shield-circle--active {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 25%, transparent);
}

.shield-circle__img {
  width: 56px;
  height: 56px;
  object-fit: contain;
}
</style>
